import { store } from '@store/store';

/**
 * Validate if action is allowed
 *
 * @param  {string[]} userRoles
 * @param  {string} allowed
 * @returns {boolean} Returns `true` if `role` exist in allowed, else `false`.
 * @example
 *
 * isAllowed(["ADMIN"], "TRANSACTIONS")
 * // => True
 *
 * isAllowed(["SELLER"], "REFUND")
 * // => False
 *
 * isAllowed(["GENERAL"], "REFUND")
 * // => False
 *
 */
export const isAllowed = (action) => {
  const { accessControl } = store.getState().login;
  return accessControl.indexOf(action) !== -1;
};
